module.exports = __webpack_public_path__ + "img/logo_rapi.54261327.png";